import styled from 'styled-components'
import { ComponentPropsWithoutRef } from 'react'
import breakpoints from "../config/Breakpoints";

type Heading = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span'
type Props = ComponentPropsWithoutRef<'p'> & {
	heading?: Heading
	size?: number
    sizeMd?: number
	bold?: boolean
}

export function Author({ heading = 'h6', size, sizeMd, bold = false, className, ...rest }: Props) {
	return <AuthorBase as={heading} className={`clamp-1-line ${className ?? ''}`} $size={size} $bold={bold} {...rest} />
}

const AuthorBase = styled.p<{ $size?: number; $bold?: boolean }>`
	color: var(--sub-text-color);
	font-size: ${({ $size }) => `${$size}px`};
	font-weight: ${({ $bold }) => ($bold ? 'bold' : 'normal')};

    @media screen and (max-width: ${breakpoints.md}) {
        font-size: ${({ $size }) => `${($size ?? 12) * 0.9}px`};
    }
`
